import { lazy } from 'react';

import type { RouteComponentProps } from 'react-router-dom'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import messages from './messages'

const IntegrationMergeDetailsViewChunk = lazy(() =>
  import('../containers/IntegrationMergeDetailsView').then(
    ({ IntegrationMergeDetailsView }) => ({
      default: IntegrationMergeDetailsView,
    })
  )
)

export const IntegrationMergePage = (props: RouteComponentProps) => {
  const { url } = useAppRoutes()
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.IntegrationMergeQboPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          link: url('IntegrationsPage'),
          name: intl.formatMessage(messages.integrationsListTitle),
        },
        {
          name: intl.formatMessage(messages.IntegrationMergeQboPageTitle),
          escapeCaseFormatting: true,
        },
      ]}
    >
      <IntegrationMergeDetailsViewChunk {...props} />
    </Page>
  )
}
